import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NotificationService } from "../../../services/notification.service";
import { EMAIL, PASSWORD, PasswordPolicy, ALPHA_NUMERIC } from '../../../components/forms/form-validation';
import {
  CREATE_CUSTOM_API, LIST_ALL_API_KEY, LIST_API
} from '../../../../config';

import { ApiService } from '../../../services/api.service';
import { DataService } from '../../../services/data.service';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Http } from '@angular/http';
import { take } from 'rxjs/operators';
import { TwoFactorAuthService } from '../../../../services/two-factor-auth.service';
@Component({
  selector: 'app-create-api-key',
  templateUrl: './create-api-key.component.html',
  styleUrls: ['./create-api-key.component.css']
})
export class CreateApiKeyComponent implements OnInit {

  searchApiKey = '';
  @Output()public clickOutside = new EventEmitter<any>();
  @Output()public searchData = new EventEmitter<any>();
  frmCreateEditApiKey: UntypedFormGroup;
  @Input() helpsection;
  @Input() serachdata;
  @Input() editFlag: boolean = false;
  @Input() ipMandatory: boolean;
  @Output() onCreateApiKey = new EventEmitter< any >();
  savingdata;
  checkedPermissionList = [];
  apilist = [];
  createAPIKeyType = '';
  popRef: NgbActiveModal;
  editApiKey = false;
  deleteApiKey = false;
  newAPIKey = '';
  showCreateApi = false;
  isNewApiCopied: boolean;
  createAPIKeyMsg = '';
  permission = 1;
  showPermissionSelect = false;
  checkAllPermission : boolean = true;
  @ViewChild('addCustomApi') addCustomApi;

  dispNewKey = false;
  constructor(
    public DataService: DataService,
    private fb: UntypedFormBuilder,
    private modalService: NgbModal,
    private http: Http,
    private apiService: ApiService,
    public notification: NotificationService,
    private twoFactorAuthService: TwoFactorAuthService
  ) { }
  apiKeySource;


  ngOnInit() {
    this.fetchAllApiList();
  }

  ngAfterViewInit(){
    console.log(this.helpsection);
  }

  fetchAllApiList() {
    this.apiService.get(LIST_API).subscribe(result => {
      if (result['status'] === 'success') {
        this.apilist = result['data'];
      } else {
      }
    });
  }

  openPopUp(savedetails) {
    this.setEditAPIkeyDetails(savedetails)
  }

  /** Opens generate drawer; 2FA runs on Generate / Update inside the drawer. */
  requestGenerateApiKeyModal(): void {
    this.displayCreationApiKey(this.addCustomApi, 1);
  }

  displayCreationApiKey(popupDetails = [],poupflag) {
   
    if(poupflag == 2){   // on edit API key popup
      this.editApiKey = true;
    }
    else{   // on create API key popup
      this.editApiKey = false;
    }

    this.isNewApiCopied = false;

    this.clearMessages();
    if (this.editApiKey == false) {
      this.savingdata = [];
      this.clearCheckList();
    }

    this.showCreateApi = true;

    this.checkedPermissionList = [];
    this.frmCreateEditApiKey = this.fb.group({
      apikeyname: ['', [Validators.required, Validators.maxLength(50), Validators.pattern(ALPHA_NUMERIC)]],
      apipermission: [''],
      allowedips: ['',[Validators.required]]
    });
    if(this.ipMandatory === false){
      this.frmCreateEditApiKey.get('allowedips').clearValidators();
    }
    this.frmCreateEditApiKey.patchValue({ apipermission: 1 });
    this.popRef = this.modalService.open(popupDetails, { windowClass: 'right-side-modal' });
  }

  onSearch(query) {
    this.searchData.emit(query);
  }

  createAPIKey(formData, flag = 1) {
    const action = +flag === 1 ? 'api_key_generate' : 'api_key_update';
    this.twoFactorAuthService
      .ensureTwoFactorValid(action)
      .pipe(take(1))
      .subscribe((allowed) => {
        if (!allowed) {
          return;
        }
        this.postCreateOrUpdateApiKey(formData, flag);
      });
  }

  private postCreateOrUpdateApiKey(formData, flag: number) {
    if (+formData['apipermission'] === 1 || formData['apipermission'] === '') {
      this.checkedPermissionList = [];
      for (let i = 0; i < this.apilist.length; i++) {
        this.checkedPermissionList.push(this.apilist[i]['id']);
      }
    }
    if (flag == 1) {
      this.savingdata = [];
    }
    const data = {
      id: (+flag !== 1) ? this.savingdata['id'] : '',
      label: formData['apikeyname'],
      mode: flag,
      per: formData['apipermission'] == '' ? 1 : formData['apipermission'],
      ips: formData['allowedips'] !== undefined ? formData['allowedips'] : '',
      permission: this.checkedPermissionList
    };

    this.apiService.post(CREATE_CUSTOM_API, data).subscribe(result => {
      if (result['status'] === 'success') {
        this.newAPIKey = (+flag == 1) ? result['data'] : '';
        this.showList();
        const emitNewKeyData = {
          newAPIKey: this.newAPIKey,
          createAPIKeyMsg: result['message'],
          createAPIKeyType: 'info'
        };

        this.onCreateApiKey.emit(emitNewKeyData);

        if (!this.newAPIKey) this.notification.showSuccess(result['message']);

      } else {
        this.dispNewKey = false;
        if (!this.newAPIKey) this.notification.showError(result['error_info']['message']);
        console.log(this.newAPIKey);
      }
    });
    this.popRef.close();
  }

  showList() {
    
    this.serachdata = '';
    this.showPermissionSelect = false;
    this.checkedPermissionList = [];
    this.showCreateApi = false;
    this.editApiKey = this.deleteApiKey = false;
  }

  onRadioChangeEvent(e) {
    
    this.permission = e.source.value
    switch (+this.permission) {
      case 1:
        this.showPermissionSelect = false;
        break;

      case 2:
        this.showPermissionSelect = true;
        break;

      default:
        this.showPermissionSelect = false;
        break;
    }
  }

  onPermissionCheckboxClick(state, eventVal) {     //on toggle of checkbox
    if (state === true) {    // insert column
      this.insertCheckedElement(eventVal);
      console.log(eventVal);
    }
    else {
      this.removeCheckedElement(eventVal);
    }
  }

  insertCheckedElement(elem) {     // add as checked permission api list
    this.checkedPermissionList.push(elem);
  }

  removeCheckedElement(elem) {    // remove from checked permission api list
    this.checkedPermissionList.splice(this.checkedPermissionList.indexOf(elem), 1);
  }

  setEditAPIkeyDetails(savedata) {
    
    this.savingdata = savedata;
    this.displayCreationApiKey(this.addCustomApi,2);

    // set form valuesfrmCreateEditApiKey
    this.frmCreateEditApiKey.patchValue({
      apikeyname: this.savingdata['label'],
      allowedips: this.savingdata['ip'],
      apipermission: this.savingdata['per']
    });

    // set selection on checkboxes based on permission
    if (+this.savingdata['per'] === 2) {

      this.showPermissionSelect = true;
      this.checkAllPermission = false;
      this.checkedPermissionList = [];
      for (let i = 0; i < +this.apilist.length; i++) {
        this.apilist[i]['selected'] = false;
        for (let j = 0; j < +this.savingdata['permission'].length; j++) {
          if (this.savingdata['permission'][j] == this.apilist[i]['id']) {
            console.log("api name--->", this.apilist[i]['label']);
            this.apilist[i]['selected'] = true;
            this.checkedPermissionList.push(this.apilist[i]['id']);
          }
        }
      }

    } else {
      this.clearCheckList();
    }

  }

  clearCheckList() {
    this.checkAllPermission = true;
    this.showPermissionSelect = false;
    for (let i = 0; i < this.apilist.length; i++) {
      this.apilist[i]['selected'] = false;
    }
  }

  clearMessages() {
    this.dispNewKey = false;
    this.newAPIKey = this.createAPIKeyMsg = '';
  }

  cancelCreationApiKey() {
    this.serachdata = '';
    this.clearMessages();
    this.showList();
    this.popRef.close();

  }

}
